import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetailsWithProvider } from '../dasboard-admin-chart-details.model';
import { ChartValue } from '../chart/chart-value.model';
import { DateHelperService } from '../../core/services';
import { LineChartOptions } from "../chart/line-chart-options.model";
import { IPublisher } from "../../shared/publisher.model";
import { WebWorkerService } from "angular2-web-worker/web-worker.service";

@Component({
    moduleId: module.id,
    selector: 'samba-earnings',
    templateUrl: 'samba-earnings.component.html'
})

export class SambaEarningsComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() dataForToday: IDashBoardAdminChartDetailsWithProvider;
    @Input() period: string;
    @Input() showTopSectionOverlay: boolean;
    sambaEarnings: number = 0;
    chartValues: ChartValue[];
    toolTipText: string = "{2} {0} {1} ";
    chartOptions: LineChartOptions  = new LineChartOptions();
    @Output() loaded: EventEmitter<any> = new EventEmitter<Event>();

    constructor(
        private dateHelper: DateHelperService,
        private webWorkerService: WebWorkerService) {
    }

    ngOnInit() {
        this.chartOptions.legendSelector = '.custom_legend';
        this.chartOptions.yaxis = { tickColor: "#494949", tickFormatter: this.chartOptions.getMonetaryShortFormat };
        this.chartOptions.formatTooltip = '1.2-2';
        this.chartOptions.tooltipCurrency = '$ ';
    }

    private mapAllData(): void {
        this.sambaEarnings = 0;
        this.chartValues = new Array<ChartValue>();
        let publishers: IPublisher[] = new Array<IPublisher>();
        for (let item of this.data.sambaRevenues) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }
        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = new ChartValue(publisher.name);
                chartValue.identifier = publisher.id;
                let revenues = this.data.sambaRevenues.filter(x => x.publisher.id == publisher.id);
                for (let item of revenues) {
                    chartValue.data.push([this.dateHelper.getTicks(item.revenues.dateUtc), item.revenues.earning]);
                    this.sambaEarnings += item.revenues.earning;
                    chartValue.lastItemIdentifier = item.revenues.dateUtc;
                }
                this.chartValues.push(chartValue);
            }
        }
        this.loaded.emit(true);
    }

    private mapTodayData(params: any): void {
        Array.prototype.findIndex || Object.defineProperty(Array.prototype, "findIndex", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return o; o++ } return -1 } }), Array.prototype.find || Object.defineProperty(Array.prototype, "find", { value: function (r) { if (null == this) throw new TypeError('"this" is null or not defined'); var e = Object(this), t = e.length >>> 0; if ("function" != typeof r) throw new TypeError("predicate must be a function"); for (var n = arguments[1], o = 0; o < t;) { var i = e[o]; if (r.call(n, i, o, e)) return i; o++ } } });
        let publishers = new Array();
        for (let item of params.dataForToday.sambaRevenues) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }
        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = params.chartValues.find(x => x.identifier == publisher.id);
                if (chartValue) {
                    let lastValue = chartValue.data[chartValue.data.length - 1];
                    let revenues = params.dataForToday.sambaRevenues.filter(x => x.publisher.id == publisher.id);
                    for (let item of revenues) {
                        if (formatDate(item.revenues.dateUtc) == formatDate(chartValue.lastItemIdentifier)) {
                            params.sambaEarnings = params.sambaEarnings - lastValue[1] + item.revenues.earning;
                            lastValue[1] = item.revenues.earning;
                        }
                    }
                }
            }
        }
        function formatDate(date: Date) {
            let _date = new Date(date);
            let day = _date.getDate();
            let monthIndex = _date.getMonth();
            let year = _date.getFullYear();
            return year + '-' + monthIndex + '-' + day;
        }
        return params;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue) {
            this.mapAllData();
        }
        if (this.dataForToday) {
            let params = {
                dataForToday: this.dataForToday,
                chartValues: this.chartValues,
                sambaEarnings: this.sambaEarnings
            }
            if (typeof (Worker) !== "undefined") {
                this.webWorkerService.run(this.mapTodayData, params).then((res) => {
                    this.onMapTodayData(res);
                }).catch((r) => { console.log(r); });
            } else {
                let res = this.mapTodayData(params);
                this.onMapTodayData(res);
            }
        }
    }
    private onMapTodayData(res: any) {
        this.dataForToday = res.dataForToday;
        this.chartValues = res.chartValues;
        this.sambaEarnings = res.sambaEarnings;
        this.loaded.emit(true);
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/samba-earnings/samba-earnings.component.ts